package one.healthium.bland.di

import one.healthium.bland.AppLaunchViewModel
import one.healthium.bland.IfaColorThemeProvider
import one.healthium.bland.appConfig
import one.healthium.bland.presentation.navigation.main.MainViewModel
import one.healthium.bland.providers.AppIconsProvider
import one.healthium.bland.providers.AppPaywallIdProvider
import one.healthium.bland.providers.AppResourceProvider
import one.healthium.data.common.serializer.ColorThemeProvider
import one.healthium.domain.paywall.PaywallIdProvider
import one.healthium.ui.compose.components.IconsProvider
import one.primehealth.app.BaseAppConfig
import one.primehealth.app.BaseAppResourceProvider
import org.koin.core.module.dsl.factoryOf
import org.koin.core.module.dsl.singleOf
import org.koin.core.module.dsl.viewModelOf
import org.koin.dsl.bind
import org.koin.dsl.module

val composeModule = module {
    includes(composeAppPlatformModule())

    singleOf(::AppResourceProvider) bind BaseAppResourceProvider::class
    singleOf(::AppPaywallIdProvider) bind PaywallIdProvider::class
    singleOf(::AppIconsProvider) bind IconsProvider::class

    factory { appConfig(get()) }
    factory { get<BaseAppConfig>().baseUrls }

    factoryOf(::IfaColorThemeProvider) bind ColorThemeProvider::class

    viewModelOf(::AppLaunchViewModel)
    viewModelOf(::MainViewModel)
}